import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { GetActiveManagementRequestParams } from '@/hooks/useApi/useActiveManagementApi/types'
import { ActiveManagementFiltersValues } from '@/utils/constants'
import { toArrayQueryParams } from '@/utils/toArrayQueryParams'

export const mapActiveManagementFiltersGetParams = (
    filters: ActiveManagementFiltersValues
): Omit<GetActiveManagementRequestParams, 'type'> => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const params: Omit<GetActiveManagementRequestParams, 'type'> = {
        'nodeIds[]': toArrayQueryParams(filters.node),
        'tagIds[]': toArrayQueryParams(filters.tag),
        'facilityIds[]': toArrayQueryParams(filters.facility),
        'usnAccountIds[]': toArrayQueryParams(filters.usn ?? []),
        'meterIds[]': toArrayQueryParams(filters.meter),
        'subMeterIds[]': toArrayQueryParams(filters.subMeter ?? []),
        startDate: timelineValue.startDate,
        endDate: timelineValue.endDate,
        timezone: filters.timezone,
    }

    return params
}
